import { ReactFCWithChildren } from 'utils/types/common'
import { FeedUpdateHeader } from '../FeedUpdate.styles'

const Header: ReactFCWithChildren = ({ children }) => (
  <FeedUpdateHeader>{children}</FeedUpdateHeader>
)

export default Header
